import { Routes } from '@angular/router';
import { AUTH_ROUTES_PATHS } from './auth.routes.model';

export const AUTH_ROUTES: Routes = [
  {
    path: AUTH_ROUTES_PATHS.LOGIN,
    loadComponent: () => import('./login/login').then(m => m.Login),
  },
  {
    path: AUTH_ROUTES_PATHS.CREATE_ACCOUNT,
    redirectTo: ({ queryParams }) =>
      `/registration/step1?token=${queryParams['token']}`,
  },
];
